import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  script: 'data-script',
}
const qsAll = {
  sections: 'data-section-type="image-with-text"',
  images: 'data-image',
}

const iObserver = new IntersectionObserver(items => {
  const target = items[0].target
  if (items[0].isIntersecting && target.querySelector(`[${qs.script}]`)) initSection(target)
})

const initSection = (section) => {
  const images = section.querySelectorAll(`[${qsAll.images}]`)
  images.forEach(image => {
    const scriptElement = image.querySelector(`[${qs.script}]`)
    if(scriptElement) {
      const scriptHtml = scriptElement.innerHTML
      scriptElement.remove()
      image.innerHTML += scriptHtml
    }
  })
}

export const setupImageWithText = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => iObserver.observe(section))
}